import React, { useEffect } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons/faLightbulb'
import { faLightbulb as farLightbulb } from '@fortawesome/free-regular-svg-icons/faLightbulb'
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons/faPlayCircle'
import { faPlayCircle as farPlayCircle } from '@fortawesome/free-regular-svg-icons/faPlayCircle'

import { controls, active } from './spinner.module.scss'
//import { faExpand } from '@fortawesome/free-solid-svg-icons'



const SpinnerControls = ({params}) => {

    const {
        isLit,
        setIsLit,
        autoplay,
        setAutoplay,
        setHovered,
        rotate,
        autoplayPeriod
    } = params


    const toggleLit = () => setIsLit(prev => !prev) 
    const toggleAutoplay = () => setAutoplay(prev => !prev)

    
    useEffect(() => {
        var intervalHandle = null
        if(autoplay) {
            // autoplay was toggled ON
            console.assert(intervalHandle == null)
            intervalHandle = setInterval(rotate, autoplayPeriod)
        }
        else {
            // autoplay was toggled OFF
            clearInterval(intervalHandle)
            intervalHandle = null
        }

        return () => {
            // clear interval if exists
            if(intervalHandle != null) {
                clearInterval(intervalHandle)
                intervalHandle = null
            }
        }

    }, [autoplay, rotate, autoplayPeriod])

    return (
        <div 
            className={controls} 
            style={{maxWidth: "100%", margin: "auto"}}
        >
            <div 
                onClick={toggleLit} 
                onKeyPress={toggleLit} 
                onMouseEnter={() => setHovered(true)}
                tabIndex={0}
                role="switch"
                aria-checked={isLit}
            >
                {
                    isLit 
                        ? <FontAwesomeIcon icon={faLightbulb} className={active}/>
                        : <FontAwesomeIcon icon={farLightbulb} />
                }
            </div>
            <div 
                onClick={toggleAutoplay} 
                onKeyPress={toggleAutoplay} 
                tabIndex={0}
                role="switch"
                aria-checked={autoplay}
            >
                {
                    autoplay 
                        ? <FontAwesomeIcon icon={faPlayCircle} className={active}/>
                        : <FontAwesomeIcon icon={farPlayCircle} />
                }
            </div>
        </div>
    )
}


export default SpinnerControls